import { Link, Tooltip, Typography, Zoom } from "@mui/material";
import React, { useState } from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

function TooltipLocal(props) {
  const [open, setOpen] = useState(false);
  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <Tooltip
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 400 }}
      placement="top"
      arrow
      onClose={handleTooltipClose}
      open={open}
      disableFocusListener
      disableTouchListener
      cursor="pointer"
      title={
        <>
          <Typography ta color="inherit">
            {props.text}
          </Typography>
          {props.url && (
            <Link target="_blank" href={props.url} color="inherit">
              קרא עוד...{" "}
            </Link>
          )}
        </>
      }
      PopperProps={{
        disablePortal: true,
        sx: {
          "& .MuiTooltip-tooltip": {
            backgroundColor: "#4C1B72",
            fontSize: 13,
            direction: "rtl",
            padding: 1,
            paddingX: 3,
            borderRadius: 3,
            lineHeight: 1.75,
          },
        },
      }}
    >
      <QuestionMarkIcon
        onClick={handleTooltipOpen}
        sx={{
          fontSize: 12,
          alignSelf: "center",
          marginRight: "2%",
          backgroundColor: props.color ? props.color : "#4C1B72",
          borderRadius: 10,
          color: props.color ? "#4C1B72" : "white",
          padding: 0.3,
        }}
      />
    </Tooltip>
  );
}

export default TooltipLocal;
